<script lang="ts" setup>import { ref as _ref } from 'vue';

/**
 * A confirmation dialog with two actions: confirm and cancel.
 * Renders as an action sheet on mobile and a dialog on desktop.
 */
import { showError } from '@consumer/services/flash'

withDefaults(defineProps<{
  name: string
  confirmLabel?: string
  cancelLabel?: string
  danger?: boolean
  onConfirm: (() => any | Promise<any>)
}>(), { confirmLabel: 'Confirm',cancelLabel: 'Cancel',danger: false, })

let open = (defineModel<boolean>('open', { default: false }))

const emit = defineEmits<{
  cancel: []
  close: []
}>()

let confirmed = _ref(false)

function cancel () {
  open.value = false
  emit('cancel')
}

function close () {
  open.value = false
  emit('close')
}

async function confirm () {
  return __props.onConfirm()
    .then(() => {
      open.value = false
      confirmed.value = true
    })
    .catch(showError)
    .finally(() => { open.value = false })
}
</script>

<template>
  <GSheetDialog
    v-model:open="open"
    :name="name"
    width="mediumwide"
    class="g-alert-modal"
    hideCloseButton
    noFlashTarget
    @close="close"
  >
    <template v-if="$slots.header" #header>
      <span class="text-navy">
        <slot name="header"/>
      </span>
    </template>

    <div class="flex-auto flex flex-col whitespace-pre-wrap text-center">
      <slot/>
    </div>

    <template #footer>
      <div class="flex flex-col-reverse lg:flex-row gap-4">
        <GCancelButton
          :name="`cancel-confirm-modal-button-${name}`"
          :label="cancelLabel"
          @click="cancel"
        />
        <GPromiseButton
          primary
          :danger="danger"
          :disabled="confirmed"
          :name="`confirm-modal-button-${name}`"
          :label="confirmLabel"
          :onClick="confirm"
        />
      </div>
    </template>
  </GSheetDialog>
</template>
